import { render, staticRenderFns } from "./event-detail-info.vue?vue&type=template&id=e1e79058&scoped=true&"
import script from "./event-detail-info.vue?vue&type=script&lang=js&"
export * from "./event-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./event-detail-info.vue?vue&type=style&index=0&id=e1e79058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e79058",
  null
  
)

export default component.exports